import { useContext, useEffect, useState } from 'react'
import { Typography, Row, Col, Empty, Spin, Button } from 'antd'
import PropTypes from 'prop-types'
import Cards from './Cards'
import AppContext from '../context/Context'
// import NavigationMenu from './NavigationMenu'

const { Text } = Typography

export default function Products ({
  properties,
  hasMoreProperties,
  handleProperties,
  setPropertiesPage,
  propertiesPage
}) {
  const { loading } = useContext(AppContext)
  const [searchedItems, setSearchedItems] = useState([])

  useEffect(() => {
    setSearchedItems(properties || [])
  }, [properties])

  const handlePropertySearch = async () => {
    await handleProperties(propertiesPage + 1)
    setPropertiesPage(propertiesPage + 1)
  }

  return (
    <Row
      justify="center"
      style={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        marginBottom: 20
      }}
    >
      <Col
        style={{
          width: '90%',
          maxWidth: '1280px'
        }}
      >
        <Spin
          spinning={loading}
          tip="Carregando imóveis..."
          size="large"
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center'
          }}
        >
          <>
            {searchedItems && searchedItems.length >= 1
              ? (
                <>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      fontWeight: 'bold',
                      width: '100%',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginTop: 20,
                      marginBottom: 20
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 30,
                        color: '#623d19ff',
                        textAlign: 'center'
                      }}
                    >
                    Imóveis em destaque
                    </Text>
                    {/* <NavigationMenu /> */}
                  </div>
                  <Row
                    gutter={[8, 8]}
                    style={{
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginTop: 20
                    }}
                  >
                    {searchedItems.map((e, index) => (
                      <Col
                        style={{
                          display: 'flex',
                          alignContent: 'center',
                          justifyContent: 'center'
                        }}
                        key={e.descricao + index}
                        xs={24}
                        sm={24}
                        md={12}
                        lg={8}
                        xl={6}
                      >
                        <Cards {...e} />
                      </Col>
                    ))}
                  </Row>
                </>
              )
              : (
                !loading && (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description={<span>Nada foi encontrado!</span>}
                    style={{
                      marginTop: '50px'
                    }}
                  />
                )
              )}
          </>
        </Spin>
        {hasMoreProperties && (
          <Button
            type="primary"
            style={{ marginTop: 20, width: 200 }}
            onClick={handlePropertySearch}
            loading={loading}
          >
          Carregar mais imóveis
          </Button>
        )}
      </Col>
    </Row>
  )
}
Products.propTypes = {
  properties: PropTypes.array.isRequired,
  hasMoreProperties: PropTypes.bool,
  handleProperties: PropTypes.func.isRequired,
  setPropertiesPage: PropTypes.func.isRequired,
  propertiesPage: PropTypes.number.isRequired
}
